import { createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import { appConfig } from "../../utils/appConfig";
import { AUTH_CODE, GENERAL_CODE } from "../../utils/message";

const initialState = {
  userState: {
    accessToken: localStorage.getItem(appConfig.JWT_KEY) || "",
  },
  isLogin: false,
  partnerIsWaiting: false,
  partnerIsRejected: false,
  errorMessage: "",
  isForgotPassword: false,
  isResetPassword: false,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginRequest: (state) => {
      state.isLogin = true;
      state.errorMessage = null;
    },
    loginSuccess: (state, { payload }) => {
      state.isLogin = false;
      state.errorMessage = null;
      state.userState = payload;
      localStorage.setItem(appConfig.JWT_KEY, payload.accessToken);
      if (payload.remember) {
        localStorage.setItem(appConfig.USER_KEY, payload.email);
        localStorage.setItem(appConfig.PASSWORD_KEY, payload.password);
      } else {
        localStorage.removeItem(appConfig.USER_KEY);
        localStorage.removeItem(appConfig.PASSWORD_KEY);
      }
    },
    loginFailure: (state, { payload }) => {
      state.isLogin = false;
      if (payload) {
        state.errorMessage = {
          text: AUTH_CODE[payload] || GENERAL_CODE[payload] || payload,
          type: "error",
        };
      } else {
        state.errorMessage = {
          text: "Missing field or wrong email format.",
          type: "error",
        };
      }
    },
    logoutRequest: (state) => {
      state.errorMessage = null;
    },
    logoutSuccess: (state) => {
      state.userState = {};
      state.errorMessage = null;
      state.partnerIsWaiting = false;
      state.partnerIsRejected = false;
      localStorage.removeItem(appConfig.JWT_KEY);
      message.success({
        key: "logout-success",
        content: "Logout successfully!",
      });
    },
    registerPartnerRequest: (state) => {
      state.isRegister = true;
      state.errorMessage = null;
    },
    registerPartnerSuccess: (state, { payload }) => {
      state.isRegister = false;
      state.errorMessage = null;
    },
    registerPartnerFailure: (state, { payload }) => {
      state.isRegister = false;
      if (payload) {
        state.errorMessage = {
          text: AUTH_CODE[payload] || GENERAL_CODE[payload] || payload,
          type: "error",
        };
      } else {
        state.errorMessage = {
          text: "Missing field or wrong email format.",
          type: "error",
        };
      }
    },
    alertWaiting: (state, { payload }) => {
      state.isLogin = false;
      state.userState = {};
      state.errorMessage = {
        text:
          AUTH_CODE[payload.text] ||
          GENERAL_CODE[payload.text] ||
          payload.text ||
          "Waiting",
        type: "warning",
      };
      if (payload.remember) {
        localStorage.setItem(appConfig.USER_KEY, payload.email);
        localStorage.setItem(appConfig.PASSWORD_KEY, payload.password);
      } else {
        localStorage.removeItem(appConfig.USER_KEY);
        localStorage.removeItem(appConfig.PASSWORD_KEY);
      }
    },
    alertRejected: (state, { payload }) => {
      state.isLogin = false;
      state.userState = {};
      state.errorMessage = {
        text:
          AUTH_CODE[payload.text] ||
          GENERAL_CODE[payload.text] ||
          payload.text ||
          "Rejected",
        type: "error",
      };
      if (payload.remember) {
        localStorage.setItem(appConfig.USER_KEY, payload.email);
        localStorage.setItem(appConfig.PASSWORD_KEY, payload.password);
      } else {
        localStorage.removeItem(appConfig.USER_KEY);
        localStorage.removeItem(appConfig.PASSWORD_KEY);
      }
    },
    forgotPasswordRequest: (state) => {
      state.isForgotPassword = true;
      state.errorMessage = null;
    },
    forgotPasswordSuccess: (state) => {
      state.isForgotPassword = false;
      state.errorMessage = null;
    },
    forgotPasswordFailure: (state, { payload }) => {
      state.isForgotPassword = false;
      if (payload) {
        state.errorMessage = {
          text: AUTH_CODE[payload] || GENERAL_CODE[payload] || payload,
          type: "error",
        };
      } else {
        state.errorMessage = "Internal Server Error.";
      }
    },
    resetPasswordRequest: (state) => {
      state.isResetPassword = true;
      state.errorMessage = null;
    },
    resetPasswordSuccess: (state) => {
      state.isResetPassword = false;
      state.errorMessage = null;
    },
    resetPasswordFailure: (state, { payload }) => {
      state.isResetPassword = false;
      if (payload) {
        state.errorMessage = {
          text: AUTH_CODE[payload] || GENERAL_CODE[payload] || payload,
          type: "error",
        };
      } else {
        state.errorMessage = "Internal Server Error.";
      }
    },
  },
});

export const {
  loginRequest,
  loginSuccess,
  loginFailure,
  logoutRequest,
  logoutSuccess,
  registerPartnerRequest,
  registerPartnerSuccess,
  registerPartnerFailure,
  alertWaiting,
  alertRejected,
  forgotPasswordRequest,
  forgotPasswordSuccess,
  forgotPasswordFailure,
  resetPasswordRequest,
  resetPasswordSuccess,
  resetPasswordFailure,
} = authSlice.actions;

export default authSlice.reducer;
